<template>
  <v-row align="center" justify="center">
    <v-col class="text-center px-5" cols="12" md="9">
      <v-col cols="12">
        <v-btn icon title="Construir Número" aria-label="Construir Número">
          <v-icon class="iconos" size="60">fas fa-chalkboard-teacher</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <span
          class="font-weight-bold leading--text mb-3"
          :style="
            $vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'
          "
          >Construir Número</span
        >
        <v-form ref="form" lazy-validation>
          <v-col cols="12" md="8" class="mt-4 mx-auto">
            <generate-number es-crear-numero v-model="numero"></generate-number>
            <v-row>
              <v-col cols="4"
                ><form-input
                  label="Año"
                  placeholder="Introduzca el año"
                  v-model="año"
                  maxlength="4"
                  :onlyNumber="true"
                  :isCenter="true"
                  hint="Solo números"
                  :required="true"
                ></form-input
              ></v-col>
              <v-col cols="4"
                ><form-input
                  label="Código de Proceso"
                  placeholder="Introduzca código"
                  v-model="codigo"
                  :onlyNumber="true"
                  :isCenter="true"
                  hint="Solo números"
                  maxlength="5"
                  :required="true"
                ></form-input
              ></v-col>
              <v-col cols="4"
                ><form-input
                  label="Recurso del proceso"
                  placeholder="Introduzca el recurso del proceso"
                  v-model="instancia"
                  :onlyNumber="true"
                  :isCenter="true"
                  hint="Solo números"
                  maxlength="2"
                  :required="true"
                ></form-input
              ></v-col>
            </v-row>
            <v-row>
              <v-text-field
                :value="numeroProceso"
                readonly
                color="cyan darken"
                label="Número de Proceso"
                placeholder="Esperando..."
                class="centered-input"
                loading
              >
                <template v-slot:progress>
                  <v-progress-linear
                    :value="progress"
                    :color="color"
                    absolute
                    height="5"
                  ></v-progress-linear>
                </template>
              </v-text-field>
            </v-row>
            <div>
              <v-btn
                :loading="findBtnLoading"
                color="success"
                :class="`${
                  $vuetify.breakpoint.xs ? 'mt-4 ' : ' '
                } mx-2 font-weight-bold`"
                width="200"
                aria-label="Construir Número"
                @click="consultar"
                >Consultar</v-btn
              >

              <v-btn
                :class="`${
                  $vuetify.breakpoint.xs ? 'mt-4 ' : ' '
                } mx-2 font-weight-bold`"
                width="200"
                dark
                color="grey"
                @click="reset"
                aria-label="Nueva Consulta"
                >Nueva Consulta</v-btn
              >
            </div>
          </v-col>
        </v-form>
      </v-col>
    </v-col>
  </v-row>
</template>
<script>
//Config
// // // import axios from "@/config/axios";
import { mapGetters } from "vuex";


//Components
import GenerateNumber from "@/components/GenerateNumber";
import FormSelect from "@/components/FormSelect";
import FormInput from "@/components/FormInput";
import FormButton from "@/components/FormButton";

export default {
  components: {
    GenerateNumber,
    FormSelect,
    FormInput,
    FormButton,
  },
  data() {
    return {
      tab: "",
      info: null,

      //Data
      numero: "",
      año: "",
      codigo: "",
      instancia: "",
      // numeroProceso: "",
      results: "",

      //Loading
      findBtnLoading: false,
    };
  },
  methods: {
    consultar() {
      // // if (this.validateForm()) {
      if (this.$refs.form.validate()) {
        this.$emit("clear-process-id");
        this.$store.dispatch("process/setProcesos", []);
        this.$store.dispatch("process/setPaginaProcesos", 1);
        this.$store.commit("process/setPaginacion", {
          name: "paginacionProcesos",
          value: {
            ...this.getPaginacionProcesos,
            pagina: 1,
          },
        });
        this.find();
      }
    },
    async find() {
      try {
        if (this.$refs.form.validate()) {
            this.findBtnLoading = true;
            
            let payload = {
               id: this.numeroProceso,
               soloActivos: false
            };
            await this.$store.dispatch("process/numRadicacion", payload);
            this.findBtnLoading = false;
            if (!this.getProcesos.length) {
               this.consulted = true;
               if (!this.getStatus.error) {
                  this.$store.dispatch(
                     "process/mostrarNotificacionRespuestaVacia",
                     this.soloActivos
                  );
               } else {
                  this.$store.dispatch("process/mostrarNotificacionError");
               }
            } else {
               if (this.getProcesos.length > 1) {
               this.$store.dispatch(
                  "process/mostraNotificacionVariosRegistros",
                  "razon-social"
               );
               }
               this.$emit("go-to-list");
            }
            this.duplicated = 0;
         }
      } catch (error) {
        console.log(error);
        this.findBtnLoading = false;
      }
    },
    reset() {
      this.show = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$store.dispatch("process/clearProcesos");
      
      //this.numeroProceso = "";
      this.duplicated = 0;
      this.$bus.emit("clear-generate-number");
    },

  },
  computed: {
      ...mapGetters("process", [
      "getProcesos"
    ]),
    numeroProceso(){
      // Se cambia 11011 (Altas Cortes) por 11001 (Bogotá) al mostrar el número
      let aux = `${this.numero.substring(0,5)==='11011'?'11001'+this.numero.substring(5):this.numero ||''}${
        this.año||''}${this.codigo||''}${this.instancia||''}`
      console.log('aux') 
      console.log(aux) 
      return (aux);
    },
    progress() {
      return Math.min(100, this.numeroProceso.length * 4.34);
    },
    color() {
      return ["error", "warning", "success"][Math.floor(this.progress / 40)];
    },
  },
};
</script>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
